import TruncatedText from "../../../../../carecoordinator/patient/TruncatedText";
import { getFullName } from "../../../utils";
import PatientDetailsField from "./PatientDetailsField";

const PatientContactSection = ({
  title,
  contact,
  fields,
  selectedYear,
  setSelectedYear,
  joiningDate,
}) => {
  if (!contact) return null;

  return (
    <div className="my-4">
      <div className="patient-profile-contact-section">{title}</div>
      <div
        className={`profile-description-section ${selectedYear && "mileage-description-section"}`}
      >
        {fields.map(({ label, key, isFullName, showSelect }) => {
          let value = null;

          if (isFullName) {
            value = getFullName(contact?.givenName, contact?.familyName);
          } else {
            value = contact?.[key];
          }

          if (Array.isArray(value) && value?.length) {
            value = value.join(", ");
          }

          return (
            value !== null &&
            value !== undefined && (
              <PatientDetailsField
                key={label}
                header={label}
                info={<TruncatedText text={value} />}
                showSelect={showSelect}
                selectedYear={selectedYear}
                setSelectedYear={setSelectedYear}
                joiningDate={joiningDate}
              />
            )
          );
        })}
      </div>
    </div>
  );
};

export default PatientContactSection;
